import axios, { HttpStatusCode } from "axios";

const API_ADDRESS = `${process.env.REACT_APP_OC_API}`;
const DEFAULT_REQUEST_TIMEOUT = 30000; //3 second timeout
const APIHelper = {
	AbortSignal: (timeoutMs?: number) => {
		if (timeoutMs === undefined) timeoutMs = DEFAULT_REQUEST_TIMEOUT;
		return AbortSignal.timeout(DEFAULT_REQUEST_TIMEOUT);
	},
	TimeoutExceeded: () => {
		console.log("Request aborted by cancellation token");
		return { status: HttpStatusCode.GatewayTimeout };
	},
};
export const BaseController = {
	CreateAPI(baseurl: string) {
		const api = axios.create({
			timeout: DEFAULT_REQUEST_TIMEOUT,
			headers: { "Content-Type": "application/json" },
			baseURL: `${API_ADDRESS}/${baseurl}`,
		});
		api.interceptors.response.use(
			(response) => response,
			(error) => {
				if (error.response) return error.response;
				if (error?.code === "ERR_CANCELED" || error?.code === "ECONNABORTED")
					return APIHelper.TimeoutExceeded();
			}
		);
		return api;
	},
};
